export const TOTAL_STEPS = 2; // 3 when including payment step